module.exports = __webpack_public_path__ + "img/location.01db8c22.svg";